import { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Drivers from "./scenes/drivers";
import Verification from "./scenes/verification";
import Rides from "./scenes/rides";
import DriverRides from "./scenes/driverrides";
import UserRides from "./scenes/userrides";
import Payments from "./scenes/payments";
import Settings from "./scenes/settings";
import { LoadScript } from '@react-google-maps/api';
import Map2 from "./map2";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Edit from "./scenes/edit";
import Login from "./scenes/login";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { Toaster } from 'react-hot-toast';
import Map from "./map";
import { fetchMapsApiKey } from "./config";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [authToken, setAuthToken] = useState("");
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapsApiKey, setMapsApiKey] = useState("AIzaSyDnDFcEd8Z49W8O7H8eNFNQ2-4fK79LMiA");

  useEffect(() => {
    const storedAuthToken = sessionStorage.getItem("authToken");
    setAuthToken(storedAuthToken);

    fetchMapsApiKey().then((key) => {
      if (key) setMapsApiKey(key);
    });

    // Fallback: Si le script Google Maps tarde ou échoue, ne jamais bloquer l'accès à l'administration
    const fallbackTimer = setTimeout(() => {
      setMapLoaded(true);
    }, 1500);

    return () => clearTimeout(fallbackTimer);
  }, []);

  const handleLoadScript = () => {
    setMapLoaded(true);
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <ToastContainer />

          {mapsApiKey ? (
            <LoadScript
              googleMapsApiKey={mapsApiKey}
              onLoad={handleLoadScript}
              onError={() => setMapLoaded(true)}
            >
              {mapLoaded ? (
                authToken ? (
                  <>
                    <Sidebar isSidebar={isSidebar} />
                    <main className="content">
                      <Topbar setAuthToken={setAuthToken} setIsSidebar={setIsSidebar} />
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/edit/:type/:table/:id" element={<Edit />} />
                        <Route path="/team" element={<Team />} />
                        <Route path="/users" element={<Contacts />} />
                        <Route path="/drivers" element={<Drivers />} />
                        <Route path="/invoices" element={<Invoices />} />
                        <Route path="/verification" element={<Verification />} />
                        <Route path="/drivers-map" element={<Map />} />
                        <Route path="/rides" element={<Rides />} />
                        <Route path="/driver/rides/:id" element={<Rides />} />
                        <Route path="/user/rides/:id" element={<Rides />} />
                        <Route path="/ride/:id" element={<Map2 />} />
                        <Route path="/payments" element={<Payments />} />
                        <Route path="/settings" element={<Settings />} />
                      </Routes>
                    </main>
                  </>
                ) : (
                  <Login setAuthToken={setAuthToken} />
                )
              ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#fff' }}>
                  Chargement de LinkerVTC Admin...
                </div>
              )}
            </LoadScript>
          ) : (
            <div>Chargement de la configuration Maps...</div>
          )}
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
